import AuthService from './services/AuthService';
import TermsService from './services/TermsService';
import { SystemFlagsService } from './services/systemFlags/SystemFlagsService';
import { V3HandoffService } from './services/V3HandoffService';
import AccountUserService from './services/AccountUserService';
import ApiTokensService from './services/ApiTokensService';
import BillingInvoiceService from './services/BillingInvoiceService';
import AssetService from './services/AssetService';
import BulkTagsService from './services/BulkTagsService';
import Utilities from './services/Utilities';
import TargetService from './services/targetService';
import CapSettingsService from './services/CapSettingsService';
import TcpaShieldService from './services/TcpaShieldService';
import DateTimeService from './services/DateTimeService';
import SavedReportService from './services/SavedReportService';
import UserSettingsService from './services/UserSettingsService';
import ClipboardService from './services/ClipboardService';
import CsvExportService from './services/CsvExportService';
import InfoService from './services/InfoService';
import InvitesService from './services/InvitesService';
import BlockedNumberService from './services/BlockedNumberService';
import BulkBlockedNumberService from './services/BulkBlockedNumberService';
import CampaignService from './services/CampaignService';
import CallAnnotationService from './services/CallAnnotationService';
import CallsService from './services/CallsService';
import TagLookupService from './services/TagLookupService';
import BuyerRegistrationService from './services/BuyerRegistrationService';
import UserGroupService from './services/UserGroupService';
import TwoFactorAuthService from './services/TwoFactorAuthService';
import UrlParameterService from './services/UrlParameterService';
import CallFlowService from './services/CallFlowService';
import ChangeLogService from './services/ChangeLogService';
import AuthConnectionService from './services/AuthConnectionService';
import PredictiveRoutingService from './services/PredictiveRoutingService';
import HttpRequestService from './services/HttpRequestService';
import PublisherService from './services/PublisherService';

import RateLimitService from './services/RateLimitService';

import RtbLogsService from './services/RtbLogsService';
import RingTreeTargetDashboardService from './services/RingTreeTargetDashboardService';

import FilterService from '@/modules/reporting/services/FilterService';
import CannedReportsService from '@/modules/reporting/services/CannedReportsService';
import ReportingService from '@/modules/reporting/services/ReportingService';
import SavedInsightService from '@/modules/reporting/services/SavedInsightService';
import AgGridService from '@/modules/reporting/services/AgGridService';
import ReportingCallLogsGridService from '@/modules/reporting/services/ReportingCallLogsGridService';

import EventInsightsService from '@/modules/reporting/event-insights/services/EventInsightsService';

import DynamicInboundCallsService from '@/modules/dynamicInboundCalls/services/DynamicInboundCallsService';

import IntegrationService from './services/IntegrationService';
import NumberService from './services/NumberService';
import OauthService from './services/OauthService';

import { highlightMatches } from './utilities/highlightMatches';
import { ngVueEventBus } from './utilities/ngVueEventBus';
import * as rootMutationTypes from '@/store/mutationTypes';
import store from '@/store';
import WebhookService from './services/WebhookService';
import TagService from './services/TagService';
import NumberPoolService from './services/NumberPoolService';
import SupportChatService from './services/SupportChatService';
import BuyerServiceV2 from './services/BuyerServiceV2';
import RingTreeService from './services/RingTreeService';

import TextToSpeechService from './services/TextToSpeechService';

import { AppConfig } from '@/appConfig';
import * as pvtUtils from '@ringba/config/pvt-utils';
import { apiUrlInterceptor } from './services/apiUrlInterceptor';
import { AppStoragesProvider } from './services/appStorages';
import { buildChangeList } from '@/core/components/ChangeLog/change-list';

export default angular
  .module('ringbaPortal.services', [
    'angular-logger',
    'LocalStorageModule',
    'ngFileUpload',
    'toaster',
    'ui.router',
    'feature-flags'
  ])
  .constant('_', window._)
  .constant('moment', window.moment);

// Every config field is injectable under its own name.
for (const [name, value] of Object.entries(AppConfig)) {
  angular.module('ringbaPortal.services').constant(name, value);
}

angular.module('ringbaPortal.services').config([
  '$compileProvider',
  $compileProvider => {
    $compileProvider.debugInfoEnabled(AppConfig.angularDebugInfoEnabled);
    $compileProvider.commentDirectivesEnabled(false);
  },
]);

angular.module('ringbaPortal.services').factory('VuexMutationTypes', [
  () => {
    return {
      ...rootMutationTypes
    };
  }
]);

angular.module('ringbaPortal.services').factory('VuexStore', [() => store]);
angular
  .module('ringbaPortal.services')
  .factory('ngVueEventBus', [() => ngVueEventBus]);

// Factory for pvt-utils - wraps the ES6 module for AngularJS injection
angular.module('ringbaPortal.services').factory('pvtUtils', [() => pvtUtils]);

angular.module('ringbaPortal.services').constant('buildChangeList', buildChangeList);
angular.module('ringbaPortal.services').constant('highlightMatches', highlightMatches);

angular.module('ringbaPortal.services').factory('apiUrlInterceptor', ['$q', 'ngAuthSettings', apiUrlInterceptor]);

angular.module('ringbaPortal.services').service('authService', AuthService);
angular.module('ringbaPortal.services').service('termsService', TermsService);
angular.module('ringbaPortal.services').provider('appStorages', AppStoragesProvider);
angular.module('ringbaPortal.services').service('systemFlagsService', SystemFlagsService);
// Started at boot, so the provider is already initializing when the first navigation sets the account.
angular.module('ringbaPortal.services').run(['systemFlagsService', (flags) => flags.start()]);
angular.module('ringbaPortal.services').service('v3HandoffService', V3HandoffService);
angular.module('ringbaPortal.services').service('oauthService', OauthService);
angular
  .module('ringbaPortal.services')
  .service('integrationService', IntegrationService);
angular
  .module('ringbaPortal.services')
  .service('apiTokensService', ApiTokensService);
angular
  .module('ringbaPortal.services')
  .service('billingInvoiceService', BillingInvoiceService);
angular.module('ringbaPortal.services').service('assetService', AssetService);
angular.module('ringbaPortal.services').service('numberService', NumberService);
angular
  .module('ringbaPortal.services')
  .service('numberPoolService', NumberPoolService);
angular
  .module('ringbaPortal.services')
  .service('blockedNumberService', BlockedNumberService);
angular
  .module('ringbaPortal.services')
  .service('bulkBlockedNumberService', BulkBlockedNumberService);
angular
  .module('ringbaPortal.services')
  .service('bulkTagsService', BulkTagsService);
angular.module('ringbaPortal.services').service('targetService', TargetService);
angular
  .module('ringbaPortal.services')
  .service('capSettingsService', CapSettingsService);
angular
  .module('ringbaPortal.services')
  .service('buyerRegistrationService', BuyerRegistrationService);
angular
  .module('ringbaPortal.services')
  .service('tcpaShieldService', TcpaShieldService);
angular
  .module('ringbaPortal.services')
  .service('dateTimeService', DateTimeService);
angular
  .module('ringbaPortal.services')
  .service('savedReportService', SavedReportService);
angular
  .module('ringbaPortal.services')
  .service('savedInsightService', SavedInsightService);
angular.module('ringbaPortal.services').service('filterService', FilterService);
angular
  .module('ringbaPortal.services')
  .service('reportingService', ReportingService);
angular.module('ringbaPortal.services').service('agGridService', AgGridService);
angular
  .module('ringbaPortal.services')
  .service('reportingCallLogsGridService', ReportingCallLogsGridService);
angular
  .module('ringbaPortal.services')
  .service('userSettingsService', UserSettingsService);
angular
  .module('ringbaPortal.services')
  .service('clipboardService', ClipboardService);
angular
  .module('ringbaPortal.services')
  .service('csvExportService', CsvExportService);
angular.module('ringbaPortal.services').service('infoService', InfoService);
angular
  .module('ringbaPortal.services')
  .service('invitesService', InvitesService);
angular
  .module('ringbaPortal.services')
  .service('campaignServiceVue', CampaignService);
angular
  .module('ringbaPortal.services')
  .service('callAnnotationService', CallAnnotationService);
angular.module('ringbaPortal.services').service('callsService', CallsService);
angular
  .module('ringbaPortal.services')
  .service('userGroupService', UserGroupService);
angular
  .module('ringbaPortal.services')
  .service('cannedReportsService', CannedReportsService);
angular
  .module('ringbaPortal.services')
  .service('tagLookupService', TagLookupService);
angular
  .module('ringbaPortal.services')
  .service('eventInsightsService', EventInsightsService);
angular
  .module('ringbaPortal.services')
  .service('accountUserService', AccountUserService);
angular
  .module('ringbaPortal.services')
  .service('twoFactorAuthService', TwoFactorAuthService);
angular
  .module('ringbaPortal.services')
  .service('urlParameterService', UrlParameterService);
angular
  .module('ringbaPortal.services')
  .service('callFlowService', CallFlowService);
angular
  .module('ringbaPortal.services')
  .service('webhookService', WebhookService);
angular
  .module('ringbaPortal.services')
  .service('changeLogService', ChangeLogService);
angular
  .module('ringbaPortal.services')
  .service('authConnectionService', AuthConnectionService);
angular.module('ringbaPortal.services').service('vueTagService', TagService);
angular.module('ringbaPortal.services').service('rtbLogsService', RtbLogsService);
angular.module('ringbaPortal.services').service('predictiveRoutingService', PredictiveRoutingService);
angular.module('ringbaPortal.services').service('httpRequestService', HttpRequestService);

angular
  .module('ringbaPortal.services')
  .service('supportChatService', SupportChatService);

angular
  .module('ringbaPortal.services')
  .service('rtbLogsService', RtbLogsService);

angular
  .module('ringbaPortal.services')
  .service('ringTreeTargetDashboardService', RingTreeTargetDashboardService);

angular
  .module('ringbaPortal.services')
  .service('predictiveRoutingService', PredictiveRoutingService);

angular
  .module('ringbaPortal.services')
  .service('publisherService', PublisherService);

angular
  .module('ringbaPortal.services')
  .service('dynamicInboundCallsService', DynamicInboundCallsService);

angular.module('ringbaPortal.services').service('buyerService', BuyerServiceV2);

angular.module('ringbaPortal.services').service('ringTreeService', RingTreeService);

angular.module('ringbaPortal.services').service('textToSpeechService', TextToSpeechService);

angular.module('ringbaPortal.services').service('rateLimitService', RateLimitService);

// The utils here is used running the digest loop
// We could use the ngVueEventBus factory for the event bus, instead of using this service
angular.module('ringbaPortal.services').service('utilities', Utilities);

angular.module('ringbaPortal.services').run($injector => {
  authService = $injector.get('authService');
  oauthService = $injector.get('oauthService');
  integrationService = $injector.get('integrationService');
  apiTokensService = $injector.get('apiTokensService');
  billingInvoiceService = $injector.get('billingInvoiceService');
  assetService = $injector.get('assetService');
  bulkTagsService = $injector.get('bulkTagsService');
  targetService = $injector.get('targetService');
  targetGroupService = $injector.get('targetGroupService');
  pingTreeService = $injector.get('pingTreeService');
  publisherRegistrationService = $injector.get('publisherRegistrationService');
  buyerRegistrationService = $injector.get('buyerRegistrationService');
  tcpaShieldService = $injector.get('tcpaShieldService');
  dateTimeService = $injector.get('dateTimeService');
  savedReportService = $injector.get('savedReportService');
  savedInsightService = $injector.get('savedInsightService');
  filterService = $injector.get('filterService');
  reportingService = $injector.get('reportingService');
  tagService = $injector.get('tagService');
  agGridService = $injector.get('agGridService');
  userSettingsService = $injector.get('userSettingsService');
  clipboardService = $injector.get('clipboardService');
  csvExportService = $injector.get('csvExportService');
  infoService = $injector.get('infoService');
  invitesService = $injector.get('invitesService');
  $ngStateService = $injector.get('$state');
  $ngStateParamsService = $injector.get('$stateParams');
  $ngTransitionService = $injector.get('$transitions');
  utilities = $injector.get('utilities');
  numberService = $injector.get('numberService');
  numberPoolService = $injector.get('numberPoolService');
  blockedNumberService = $injector.get('blockedNumberService');
  bulkBlockedNumberService = $injector.get('bulkBlockedNumberService');
  campaignService = $injector.get('campaignServiceVue');
  reportingCallLogsGridService = $injector.get('reportingCallLogsGridService');
  callAnnotationService = $injector.get('callAnnotationService');
  callsService = $injector.get('callsService');
  affiliateService = $injector.get('affiliateService');
  buyerService = $injector.get('buyerService');
  ringTreeService = $injector.get('ringTreeService');
  callPlanService = $injector.get('callPlanService');
  pingTreeTargetService = $injector.get('pingTreeTargetService');
  featureFlags = $injector.get('featureFlags');
  v3HandoffService = $injector.get('v3HandoffService');
  cannedReportsService = $injector.get('cannedReportsService');
  dynamicInboundCallsService = $injector.get('dynamicInboundCallsService');
  accountsService = $injector.get('accountsService');
  billingService = $injector.get('billingService');
  accountSettingsService = $injector.get('accountSettingsService');
  cacheService = $injector.get('cacheService');
  tagLookupService = $injector.get('tagLookupService');
  callLogsService = $injector.get('callLogsService');
  userGroupService = $injector.get('userGroupService');
  eventInsightsService = $injector.get('eventInsightsService');
  accountUserService = $injector.get('accountUserService');
  ringbaUserService = $injector.get('ringbaUserService');
  twoFactorAuthService = $injector.get('twoFactorAuthService');
  urlParameterService = $injector.get('urlParameterService');
  callFlowService = $injector.get('callFlowService');
  rtbLogsService = $injector.get('rtbLogsService');
  ringTreeTargetDashboardService = $injector.get('ringTreeTargetDashboardService');
  webhookService = $injector.get('webhookService');
  changeLogService = $injector.get('changeLogService');
  capSettingsService = $injector.get('capSettingsService');
  columnsFetchService = $injector.get('columnsFetchService');
  statsService = $injector.get('statsService');
  vueTagService = $injector.get('vueTagService');
  tagsValuesService = $injector.get('tagsValuesService');
  authConnectionService = $injector.get('authConnectionService');
  comparisonTypeService = $injector.get('comparisonTypeService');
  predictiveRoutingService = $injector.get('predictiveRoutingService');
  publisherService = $injector.get('publisherService');
  supportChatService = $injector.get('supportChatService');
  httpRequestService = $injector.get('httpRequestService');
  textToSpeechService = $injector.get('textToSpeechService');
  rateLimitService = $injector.get('rateLimitService');
  offersService = $injector.get('offersService');
  callRouteService = $injector.get('callRouteService');
  campaignServiceNew = $injector.get('campaignServiceNew');
  oAuth = $injector.get('oAuth');
  envFeatures = $injector.get('envFeatures');
  termsService = $injector.get('termsService');
});

// Export services - START
export let authService;
export let oauthService;
export let oAuth;
/** @type {import('@ringba/config/v2').V2EnvFeatures} */
export let envFeatures;
export let integrationService;
export let apiTokensService;
export let billingInvoiceService;
export let assetService;
export let accountSettingsService;
export let textToSpeechService;

/**
 * @type {BulkTagsService}
 */
export let bulkTagsService;

export let targetService;
export let targetGroupService;
export let pingTreeService;
export let capSettingsService;
export let publisherRegistrationService;
export let buyerRegistrationService;
export let tcpaShieldService;
export let dateTimeService;
export let savedReportService;
export let savedInsightService;
export let filterService;
export let reportingService;
export let tagService;
export let agGridService;
export let $ngStateService;
export let $ngTransitionService;
export let termsService;
export let userSettingsService;
export let clipboardService;
export let csvExportService;
export let $ngStateParamsService;
export let offersService;
export let callRouteService;

/** @type {RateLimitService} */
export let rateLimitService;

/** @type {InfoService} */
export let infoService;
export let invitesService;

/** @type {Utilities} */
export let utilities;

/** @type {NumberService} */
export let numberService;

/** @type {NumberPoolService} */
export let numberPoolService;
export let blockedNumberService;
export let bulkBlockedNumberService;
export let campaignService;
export let campaignServiceNew;
export let reportingCallLogsGridService;
export let callAnnotationService;
export let callsService;
export let userGroupService;
export let affiliateService;

/** @type {BuyerServiceV2} */
export let buyerService;

export let ringTreeService;
export let callPlanService;
export let pingTreeTargetService;
export let featureFlags;
/** @type {import('./services/V3HandoffService').V3HandoffService} */
export let v3HandoffService;
export let cannedReportsService;
export let dynamicInboundCallsService;
export let accountsService;
export let billingService;
export let cacheService;
export let tagLookupService;
export let callLogsService;
export let rtbLogsService;
export let ringTreeTargetDashboardService;
export let eventInsightsService;
export let accountUserService;
export let ringbaUserService;
export let twoFactorAuthService;

/** @type {UrlParameterService} */
export let urlParameterService;
export let callFlowService;

/** @type {WebhookService} */
export let webhookService;

export let statsService;
export let changeLogService;
export let columnsFetchService;

/** @type {TagService} */
export let vueTagService;

export let tagsValuesService;

export let comparisonTypeService;

export let authConnectionService;

/** @type {PredictiveRoutingService} */
export let predictiveRoutingService;

/** @type {PublisherService} */
export let publisherService;

/** @type {SupportChatService} */
export let supportChatService;

/** @type {HttpRequestService} */
export let httpRequestService;

/** @type {UserAnalyticsService} */
export let userAnalyticsService;



// Export services - END
